import { Button } from '../common';

/**
 * 返回按钮
 * @param {String} text 按钮text
 * @param {Object} style 按钮样式覆盖
 * @param {() => void} option.onClickBack 点击关闭弹窗
 */

export const ModalBackButton = ({
  onClick,
  text = 'Back',
  style,
}) => (
  <Button
    variant="outlined"
    style={{
      border: '1px solid #BABFC3',
      borderRadius: '2px',
      color: '#202223',
      boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05)',
      padding: '8px 16px',
      height: '36PX',
      ...style,
    }}
    sx={{
      backgroundColor: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#F6F6F7',
      },
    }}
    onClick={onClick}
  >
    {text}
  </Button>
);
